import WorkService from '@/service/work';
import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';

const moChangeRate = observable({
  rateTabActive: '人均营业收入',
  rateTimeActive: '2018',
  rateList: <any>{},
});


// 修改tab
const changeTab = action(async (val: string) => {
  runInAction(() => {
    moChangeRate.rateTabActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.ratetab = val;
  localforage.setItem('humans', humanData);
});

// 修改默认tab
const changeRateTab = action(async (val: string) => {
  runInAction(() => {
    moChangeRate.rateTabActive = val;
  });
});

// 修改时间tab
const changeTimeTab = action(async (val: string) => {
  runInAction(() => {
    moChangeRate.rateTimeActive = val;
  });
  const list = await WorkService.ratioDistribution({
    year: val,
  });
  runInAction(() => {
    moChangeRate.rateList = list;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.ratetime = val;
  localforage.setItem('humans', humanData);
});

// 修改默认时间

const changeDefaltRate = action(async (val: string) => {
  runInAction(() => {
    moChangeRate.rateTimeActive = val;
  });
});

// 默认数据

const getRatioDistribution = action(async (val: any) => {
  runInAction(() => {
    moChangeRate.rateList = val;
  });
});


export default moChangeRate;
export { changeTab, changeTimeTab, changeDefaltRate, getRatioDistribution, changeRateTab };
